Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tagFontSize: 14,
    tagHeight: 20,
    tagIndicatorDiameter: 12,
    tagCloseIconMotionDuration: "100ms",
    tagCloseIconMotionFunction: "ease",
    tagCloseIconSize: 16,
    tagCloseIconColorDismissibleThemeDefault: tokens.themeActionPrimaryDefault,
    tagCloseIconColorDismissibleThemeHover: tokens.themeActionPrimaryHover,
    tagCloseIconColorDismissibleThemePressed: tokens.themeActionPrimaryPressed,
    tagCloseIconColorDismissibleThemeFocus: tokens.themeActionPrimaryDefault,
    tagCloseIconColorDismissibleNeutralDefault: tokens.themeDecorativeNeutralStrong,
    tagCloseIconColorDismissibleNeutralHover: tokens.themeInkSubdued,
    tagCloseIconColorDismissibleNeutralPressed: tokens.themeBorderStrong,
    tagCloseIconColorDismissibleNeutralFocus: tokens.themeDecorativeNeutralStrong,
    tagSpacingInsetStatusStart: 4,
    tagSpacingInsetStatusEnd: 12,
    tagSpacingInsetDismissibleStart: 8,
    tagSpacingInsetDismissibleEnd: 2,
    tagSpacingHorizontal: 8,
    tagBackgroundColorDismissibleTheme: tokens.themeDecorativePaletteSubdued,
    tagBackgroundColorDismissibleNeutral: tokens.themeDecorativeNeutralSubdued,
    tagBorderWidth: 1,
    tagBorderRadius: 13,
    tagBorderCompactWidth: 2,
    tagBorderCompactRadius: 999,
    tagBorderColorStatusSuccess: "#ADE422",
    tagBorderColorStatusWarning: "#FAD000",
    tagBorderColorStatusError: "#DE1B1B",
    tagBorderColorStatusTheme: tokens.themeDecorativePaletteDefault,
    tagBorderColorStatusNeutral: tokens.themeDecorativeNeutralDefault,
    tagBorderColorDismissibleTheme: tokens.themeDecorativePaletteHighlight,
    tagBorderColorDismissibleNeutral: tokens.themeDecorativeNeutralHighlight,
    tagBorderColorCompact: "#02080E",
    tagFocusOutlineOffset: 4
  }
};